<div
  class="panel rs-bg-grey2 rs-shadow rs-panel-clickable jsrs-clickable rs-clickable"
  data-cy="myBillLandingAccountCard"
>
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column">
      <div class="rs-flex-row rs-flex-middle">
        <div class="rs-flex-column">
          <p class="rs-tit6">{{ addressLineOne }},<br />{{ addressLineTwo }}</p>
          <p
            *ngIf="
              hasSameAddressAsAnotherAccount && singleAssociatedNumber !== ''
            "
          >
            {{ singleAssociatedNumber }}
            <br
              class="show-for-small-only"
              *ngIf="otherAssociatedNumbersListLength > 0"
            />
            <span
              class="has-tip"
              tabindex="0"
              data-tooltip=""
              *ngIf="otherAssociatedNumbersListLength > 0"
              [title]="otherAssociatedNumbersListJoined"
              data-options="show_on:medium"
              >+ {{ otherAssociatedNumbersListLength }}</span
            >
          </p>
          <p
            class="rs-txt-primary"
            *ngIf="
              (statusTranslation !== 'EMPTY' && status === 'noStatus') ||
              status === 'open'
            "
          >
            {{ statusTranslation }}
          </p>
          <p class="rs-status rs-status-nok" *ngIf="status === 'overdue'">
            <i class="rs-status-icon" aria-hidden="true"></i
            >{{ statusTranslation }}
          </p>
        </div>
        <div class="rs-flex-column rs-flex-shrink">
          <p>
            <strong>
              <px-currency-amount [amount]="billingAccount.balance">
              </px-currency-amount> </strong
            ><br />{{ 'bills.cover.vatInclusive' | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <span class="rs-panel-clickable-arrow" aria-hidden="true"></span>
    </div>
  </div>
</div>
